'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _reactRouterRedux = require('react-router-redux');

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var QuickSendFormButtons = (_dec = (0, _reactRedux.connect)(null, { pushState: _reactRouterRedux.push }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSendFormButtons, _Component);

  function QuickSendFormButtons() {
    (0, _classCallCheck3.default)(this, QuickSendFormButtons);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendFormButtons.__proto__ || (0, _getPrototypeOf2.default)(QuickSendFormButtons)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendFormButtons, [{
    key: 'onOk',
    value: function onOk() {
      var _props = this.props,
          step = _props.step,
          onSubmit = _props.onSubmit,
          onNext = _props.onNext;

      if (step === 1) {
        return onNext();
      }
      return onSubmit();
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.props.pushState('/quick-send/sent');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          submitting = _props2.submitting,
          isSubmitDisabled = _props2.isSubmitDisabled,
          step = _props2.step,
          className = _props2.className;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)('text-center', className) },
        _react2.default.createElement(
          _Button2.default,
          {
            type: 'submit',
            className: 'btn-primary wide margin-right-20 margin-top-10',
            onClick: this.onOk,
            disabled: isSubmitDisabled,
            loading: submitting
          },
          step === 1 ? t('Next') : t('Send')
        ),
        _react2.default.createElement(
          _Button2.default,
          { className: 'btn-stroke wide margin-top-10', onClick: this.cancel },
          t('Cancel')
        )
      );
    }
  }]);
  return QuickSendFormButtons;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  isSubmitDisabled: _propTypes2.default.bool,
  onNext: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  pushState: _propTypes2.default.func,
  step: _propTypes2.default.number,
  submitting: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  onNext: _noop3.default,
  onSubmit: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onOk', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onOk'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cancel', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancel'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = QuickSendFormButtons;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/form/QuickSendFormButtons.js
// module id = 2081
// module chunks = 1